import QueryString from 'qs'
import { apiClient } from '../client'
import { ContactProfileListPayload, ContactProfileMutationPayload, ContactProfileMutationResponse, ContactProfilePayload, ContactProfileResponse } from './types'

export const getContactProfileById = async ({ contactId, profileId }: ContactProfilePayload) => {
    const response = await apiClient(`v1/contact/${contactId}/profile/${profileId}`, {
        method: 'GET',
    })

    return response.data
}

export const getContactProfiles = async (payload: ContactProfileListPayload) => {
    const { contactId, ...params } = payload

    const response = await apiClient(`v1/contact/${contactId}/profile`, {
        params,
        paramsSerializer: (p: Omit<ContactProfileListPayload, 'contactId'>) => QueryString.stringify(p),
    })

    return response.data as ContactProfileResponse
}

export const createUpdateContactProfile = async (payload: ContactProfileMutationPayload) => {
    const { isEdit, data, contactId, profileId } = payload

    if (isEdit && !profileId) {
        throw new Error('Contact profile id is required for update')
    }

    const url = isEdit ? `v1/contact/${contactId}/profile/${profileId}` : `v1/contact/${contactId}/profile`

    const response = await apiClient(url, {
        method: isEdit ? 'PUT' : 'POST',
        data,
    })

    return response.data as ContactProfileMutationResponse
}

export const deleteContactProfile = async ({ contactId, profileId }: ContactProfilePayload) => {
    const response = await apiClient(`v1/contact/${contactId}/profile/${profileId}`, {
        method: 'DELETE',
    })

    return response.data as ContactProfileMutationResponse
}
